<div class="duration-container">
    <finder-font-icon name="{{icon}}" size="s"></finder-font-icon>
    <time title="{{alt}}" class="duration" [attr.datetime]="time | TimePeriod">
        {{label | titlecase }}
    </time>
</div>
